module.exports = __webpack_public_path__ + "img/alert_btn03_noapp.d079bf7d.png";